import React, { FC, useContext } from 'react';
import cx from 'classnames';
import CommentsList, { TCommentProps } from './CommentsList';
import { CommentsContext } from './CommentsContext';
import { CommentsListType } from './constants';

export type TCommentsThreadProps = {
  comments: TCommentProps[] | undefined;
  isCommentThreadOpen?: boolean;
  loading: boolean;
  error?: any;
  commentsListType: CommentsListType;
};

const CommentsThread: FC<TCommentsThreadProps> = ({
  isCommentThreadOpen,
  comments,
  loading,
  error,
  commentsListType,
}) => {
  const { articleId, userId, userPublicAddress, loadingAuthenticatedUserStatus } = useContext(CommentsContext);

  return (
    <div
      className={cx('pl-2 md:pl-4 border-l border-r-gray-400', {
        hidden: !isCommentThreadOpen,
        block: isCommentThreadOpen,
      })}
    >
      <CommentsList
        comments={comments}
        userPublicAddress={userPublicAddress}
        userId={userId}
        articleId={articleId}
        loading={loading}
        error={error}
        loadingAuthenticatedUserStatus={loadingAuthenticatedUserStatus}
        type={commentsListType}
      />
    </div>
  );
};

export default CommentsThread;
